/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import React from "react";
import * as S from "./styles";

function ControlButton({ title, Action, type, active, className }) {
  const actionButton = active ? " ativar função" : " desativar função";

  const HandleControl = () => {
    Action();
  };

  return (
    <div
      className={
        className
          ? `tcf-map--control__btn--container ${className}`
          : `tcf-map--control__btn--container`
      }
    >
      <button
        className={
          !active
            ? `tcf-map--control__btn`
            : "tcf-map--control__btn tcf-map--control__btn--active"
        }
        type="button"
        data-title={title}
        onClick={HandleControl}
      >
        {type === "In" ? (
          <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="32"
              height="32"
              transform="translate(0.5)"
              fill="white"
            />
            <path
              d="M16.5 11.3333V20.6667"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
            <path
              d="M11.833 16H21.1663"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </svg>
        ) : type === "Out" ? (
          <svg
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="32"
              height="32"
              transform="translate(0.5)"
              fill="white"
            />
            <path
              d="M11.833 16H21.1663"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </svg>
        ) : type === "BaseLayer" ? (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.3639 2.63609C13.664 0.936141 11.4039 0 8.99989 0C6.59587 0 4.33586 0.936176 2.63602 2.63609C0.936176 4.33596 0 6.59605 0 9.00007C0 11.4041 0.936141 13.6641 2.63602 15.364C4.33586 17.0639 6.59591 18 8.99989 18C11.4039 18 13.664 17.0639 15.3639 15.364C17.0638 13.6641 17.9999 11.4041 17.9999 9.00004C17.9999 6.59602 17.0638 4.33596 15.3639 2.63609ZM15.8226 6.28168C15.4948 6.30689 15.238 6.21172 14.9129 6.09121C14.6896 6.00848 14.4366 5.91469 14.1399 5.85573C13.3404 5.69686 12.5203 6.13273 12.0505 6.96621C11.9137 7.20893 11.2596 8.45863 11.8162 9.22535C12.0249 9.51279 12.3041 9.68017 12.5285 9.8146C12.8296 9.99506 13.1409 10.1816 13.4936 10.3239C13.5687 10.3543 13.643 10.3817 13.7149 10.4082C13.9288 10.4872 14.15 10.5688 14.2291 10.6772C14.2734 10.7378 14.3197 10.8745 14.2881 11.1808C14.267 11.3856 14.185 11.6092 14.0982 11.8459C13.8844 12.429 13.5915 13.2276 14.2778 14.0118C14.3977 14.1491 14.5364 14.2689 14.6897 14.3676C13.2619 15.8804 11.2393 16.8261 8.99989 16.8261C4.68461 16.8261 1.1739 13.3153 1.1739 9.00007C1.1739 8.16859 1.30472 7.36717 1.54603 6.61479C1.67133 6.79409 1.8128 6.95348 1.9485 7.09632C2.38427 7.55486 2.86253 7.97105 3.37686 8.33931C3.41501 8.36662 3.46932 8.40551 3.49762 8.43096C3.51696 8.51741 3.50919 8.6419 3.50044 8.78368C3.4818 9.08416 3.45625 9.49567 3.68318 9.92869C3.83101 10.2108 4.03798 10.4279 4.22058 10.6195C4.3984 10.8061 4.55196 10.9672 4.59489 11.1234C4.62547 11.2348 4.61246 11.3987 4.59865 11.5722C4.57966 11.8112 4.55811 12.0821 4.62705 12.3736C4.71973 12.7654 4.94089 13.0557 5.13601 13.3118C5.25902 13.4732 5.37521 13.6258 5.42563 13.7654C5.46448 13.8731 5.48019 14.0184 5.49675 14.1722C5.51338 14.3263 5.53226 14.5011 5.57831 14.681C5.71634 15.2202 6.16384 15.7375 6.76768 15.7375C6.79985 15.7375 6.83258 15.736 6.86563 15.733C7.49092 15.6759 7.92028 15.1172 7.98609 14.2748C7.99675 14.1385 8.0248 13.7791 8.09434 13.6998C8.11586 13.6912 8.16827 13.6784 8.20716 13.6689C8.37257 13.6284 8.62249 13.5671 8.829 13.3556C9.20936 12.9661 9.10448 12.4778 9.0418 12.186C9.02296 12.0981 9.00155 11.9985 9.00278 11.9466C9.00612 11.8075 9.29092 11.5643 9.39814 11.4727L10.471 10.5563C10.8887 10.2031 11.0449 9.58869 10.8598 9.02749C10.7276 8.62685 10.435 8.26661 10.0136 7.98564C9.49366 7.6391 8.93155 7.55026 8.4716 7.7419C8.31519 7.80704 8.18873 7.89641 8.0871 7.96823C8.05634 7.99 8.0158 8.01865 7.98282 8.03957C7.96391 8.0182 7.94752 7.99473 7.93399 7.96961C7.89532 7.89866 7.86059 7.80655 7.82378 7.70903C7.77533 7.58071 7.72042 7.43523 7.63917 7.28881C7.20439 6.50535 6.49417 6.41844 5.97561 6.35502C5.88698 6.34419 5.80324 6.33393 5.71975 6.32102C5.28321 6.25349 4.83912 6.06182 4.49821 5.79807C4.62315 5.75314 4.77587 5.71852 4.85807 5.72171C4.91755 5.72368 4.98727 5.73163 5.06116 5.74003C5.27291 5.76418 5.53634 5.79417 5.82026 5.71458C6.10689 5.63425 6.31821 5.46919 6.48798 5.33658C6.53643 5.29875 6.58216 5.263 6.62435 5.23339C6.7038 5.17764 6.85839 5.16473 7.02204 5.15106C7.42961 5.11703 8.27768 5.04626 8.39774 3.86701C8.45715 3.28356 8.24403 2.76121 8.07279 2.34148C7.93037 1.9923 7.79217 1.64573 7.67159 1.28711C8.11037 1.21181 8.55476 1.17395 8.99996 1.17394C9.97147 1.17394 10.902 1.35243 11.7611 1.67738C11.7353 1.70269 11.7095 1.72796 11.6838 1.75317C11.4229 2.00904 11.1531 2.27366 10.9675 2.51402C10.889 2.61566 10.7576 2.78571 10.7189 3.03061C10.6533 3.44609 10.9017 3.76527 11.0078 3.90154C11.1654 4.10414 11.4294 4.44326 11.8654 4.552C11.9575 4.57503 12.052 4.58667 12.147 4.58666C12.4755 4.58666 12.7549 4.44909 12.9715 4.34239C13.0963 4.28098 13.2253 4.21745 13.3024 4.21126C13.3758 4.20525 13.5053 4.24796 13.6309 4.2891C13.8142 4.34922 14.0219 4.41728 14.2667 4.42617C14.5886 4.4377 14.8741 4.32109 15.0981 4.10091C15.6178 4.74652 16.0373 5.4759 16.3328 6.26551C16.2909 6.2666 16.2483 6.2672 16.2103 6.26766C16.0951 6.26913 15.9647 6.27079 15.8226 6.28168Z"
              fill="#AFA7A1"
            />
          </svg>
        ) : type === "baseMap" ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.3334 1H15V5.66667"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.66667 15H1V10.3334"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15 1L9.55554 6.44444"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 15L6.44444 9.55554"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : type === "layers" ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 1L1 4.5L8 8L15 4.5L8 1Z"
              stroke="#AFA7A1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 11.5L8 15L15 11.5"
              stroke="#AFA7A1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 8L8 11.5L15 8"
              stroke="#AFA7A1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : type === "Legend" ? (
          <svg
            width="20"
            height="14"
            viewBox="0 0 20 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 1H19"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 7H19"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 13H19"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 1H1.01"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 7H1.01"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1 13H1.01"
              stroke="#AFA7A1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          title
        )}
      </button>
    </div>
  );
}

export default ControlButton;
